(function () {
    const card = document.querySelector('.upgrade-stack-card');
    if (!card || !window.product || !Array.isArray(window.product.variants)) return;

    const badgeEl = card.querySelector('.upgrade-stack-badge');
    const subtitleEl = card.querySelector('.upgrade-stack-subtitle');
    const benefitsEl = card.querySelector('.upgrade-stack-benefits');
    const footnoteEl = card.querySelector('.upgrade-stack-footnote');

    const defaults = {
      badge: badgeEl ? (badgeEl.dataset.default || '') : '',
      subtitle: subtitleEl ? (subtitleEl.dataset.default || '') : '',
      benefits: benefitsEl ? (benefitsEl.dataset.default || '') : '',
      footnote: footnoteEl ? (footnoteEl.dataset.default || '') : ''
    };

    function findVariant(id) {
      return window.product.variants.find(function(v) {
        return String(v.id) === String(id);
      });
    }

    function isBlank(value) {
      return value === null || value === undefined || String(value).trim() === '';
    }

    function updateStackForVariant(variantId) {
      const v = findVariant(variantId);

      if (!v || !v.metafields) {
        if (badgeEl) badgeEl.innerHTML = defaults.badge;
        if (subtitleEl) subtitleEl.innerHTML = defaults.subtitle;
        if (benefitsEl) benefitsEl.innerHTML = defaults.benefits;
        if (footnoteEl) footnoteEl.innerHTML = defaults.footnote;
        return;
      }

      if (badgeEl) {
        badgeEl.innerHTML = !isBlank(v.metafields.stack_discount)
          ? v.metafields.stack_discount
          : defaults.badge;
      }

      if (subtitleEl) {
        subtitleEl.innerHTML = !isBlank(v.metafields.stack_small_description)
          ? v.metafields.stack_small_description
          : defaults.subtitle;
      }

      if (benefitsEl) {
        benefitsEl.innerHTML = !isBlank(v.metafields.stack_benefits_points_html)
          ? v.metafields.stack_benefits_points_html
          : defaults.benefits;
      }

      if (footnoteEl) {
        footnoteEl.innerHTML = !isBlank(v.metafields.stack_footer_note_html)
          ? v.metafields.stack_footer_note_html
          : defaults.footnote;
      }
    }

    function initVariantWatcher() {
      const form = card.closest('form') || document.querySelector('form[action*="/cart/add"]');
      const idInput = form ? form.querySelector('input[name="id"]') : null;
      if (!idInput) return;

      if (idInput.value) {
        updateStackForVariant(idInput.value);
      }

      let lastVariantId = idInput.value;

      idInput.addEventListener('change', function () {
        const newVariantId = idInput.value;
        if (newVariantId && newVariantId !== lastVariantId) {
          lastVariantId = newVariantId;
          updateStackForVariant(newVariantId);
        }
      });

      const observer = new MutationObserver(function () {
        const newVariantId = idInput.value;
        if (newVariantId && newVariantId !== lastVariantId) {
          lastVariantId = newVariantId;
          updateStackForVariant(newVariantId);
        }
      });

      observer.observe(idInput, {
        attributes: true,
        attributeFilter: ['value']
      });
    }

    initVariantWatcher();
  })();